import _Field from "redux-form/es/Field";
import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { GreyUnderlinedInput } from 'swag-client-common/components/inputs/grey-underlined-input';
import { Button } from 'swag-client-common/components/ui/button';
import { required, email, minLength } from 'swag-client-common/utils/redux-form-validators';
import classes from './out-of-stock.scss';
const OutOfStock = ({
  outOfStockDate,
  title,
  text,
  isLimitedEdition,
  onSubmit,
  handleSubmit
}) => {
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form
  }, /*#__PURE__*/React.createElement("h3", {
    className: classes.title
  }, title, ' ', outOfStockDate && /*#__PURE__*/React.createElement("span", {
    className: classes.backInStock
  }, "Est. Back in stock: ", moment(outOfStockDate).format('MMMM Do'))), /*#__PURE__*/React.createElement("p", {
    className: classes.label
  }, text), /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement(_Field, {
    component: GreyUnderlinedInput,
    className: classes.formInput,
    containerClassName: classes.formInputContainer,
    type: "text",
    name: "email",
    autoComplete: "email",
    placeholder: "Enter your email",
    wrapperClassName: classes.inputInnerWrapper,
    validate: [required, email, minLength(3)]
  }), /*#__PURE__*/React.createElement(Button, {
    className: classNames(classes.button, {
      [classes.orangeButton]: isLimitedEdition
    }),
    type: "primary",
    size: "small",
    onClick: handleSubmit(onSubmit)
  }, "Submit")));
};
export default OutOfStock;